import { nString, uNumber, Uuid } from '@hidat/huijs-common';
import {
  PlayerProgramInterface,
  ProgramBrandingInterface,
  ProgramKlasses,
} from '@splixer/common';
import * as dayjs from 'dayjs';
import { PlayerExtendedBranding } from './extended-branding.model';
import { Expose, Transform, Type } from 'class-transformer';
import { dayjsTransformer } from '@hidat/huijs-dates';

export class PlayerProgramBranding
  extends PlayerExtendedBranding
  implements ProgramBrandingInterface
{
  @Expose({ name: 'broadcast_times' })
  broadcastTimes?: nString = null;
  @Expose({ name: 'keyword' })
  keyword?: nString = undefined;
}

/**
 * Player version of the program, without any includes.
 * This helps us avoid circular references
 */
export class PlayerProgramBase implements PlayerProgramInterface {
  id = -1; // Should not be used in players
  @Expose({ toClassOnly: true })
  uid: Uuid | undefined;

  @Expose({ name: 'name' })
  name: string | undefined = undefined;
  @Expose({ name: 'description' })
  description: nString = undefined;
  @Expose({ name: 'tag_line' })
  tagLine: nString = undefined;
  @Expose({ name: 'image_url' })
  imageUrl: nString = undefined;
  @Expose({ name: 'branding' })
  @Type(() => PlayerProgramBranding)
  branding: PlayerProgramBranding = {};
  @Expose({ name: 'short_code' })
  shortCode: nString = undefined;
  @Expose({ name: 'priority' })
  priority: uNumber = undefined;
  @Expose({ name: 'url_stub' })
  urlStub: nString = undefined;
  @Expose({ name: 'default_mix_id' })
  defaultMixId: number | undefined = undefined;

  @Expose({ name: 'klass' })
  klass: ProgramKlasses | undefined | null = undefined;
  @Expose({ name: 'licensing_klass' })
  licensingKlass: string | undefined = undefined;
  @Expose({ name: 'valid_segments' })
  validSegments = 0;
  @Expose({ name: 'duration' })
  duration = 0;

  @Expose({ name: 'created_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  createdAt: dayjs.Dayjs | undefined = undefined;
  @Expose({ name: 'updated_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  updatedAt: dayjs.Dayjs | undefined = undefined;
  @Expose({ name: 'status' })
  status = 100;
}
